import { useCallback } from "react";
import { redirectToIntegrator, useSessionCtx } from "utils";
import { useSettings } from "utils/settingsContext";

export const useRedirect = () => {
  const { sessionCtx } = useSessionCtx();
  const { integratorSettings } = useSettings();

  const redirectOnComplete = useCallback(
    (data) => {
      const returnUrl = redirectToIntegrator(sessionCtx, data, integratorSettings);
      return `redirect-receipt-${returnUrl}`;
    },
    [sessionCtx, integratorSettings]
  );

  return [redirectOnComplete];
};
